// extracted by mini-css-extract-plugin
export default {"extBadge":"ExternalPatientNumberBadge_extBadge__K5Gvc"};